'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.meta && action.meta.request) {
    return state.set(action.meta.request.key, action.meta.request.status);
  }
  return state;
};

var _Immutable = require('Immutable');

var initialState = (0, _Immutable.Map)();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/requestStatus.js
// module id = 531
// module chunks = 0